<button type="button" class="guest-flow-profile-card" (click)="action.emit()">
  <span class="guest-flow-profile-icon" aria-hidden="true">
    <i [class]="'publicInvite.profileNudge' | nogoshIcon" aria-hidden="true"></i>
  </span>
  <span class="guest-flow-profile-copy">
    <strong>{{ title }}</strong>
    <span>{{ description }}</span>
  </span>
  <span class="guest-flow-profile-action">{{ actionLabel }}</span>
</button>
